// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"449":"1b378468","830":"1b378468"}[chunkId] + ".chunk.js";
};